import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Container } from 'reactstrap';
import styles from './DeletedProducts.module.scss';
import ManageTable from '../../../../../views/Manage/ManageTable';
import { Loader } from 'react-feather';

const DeletedProducts = () => {
    const [loading, setLoading] = useState(true);

    // State to track dropdown open state for each row
    const [dropdownOpen, setDropdownOpen] = useState({});

    // Function to toggle dropdown for a specific row
    const toggleDropdown = (rowId) => {
        setDropdownOpen((prevState) => ({
            ...prevState,
            [rowId]: !prevState[rowId],
        }));
    };

    const data = [
        {
            id: 1,
            name: 'Blue Colored Headphones',
            sku: 'Example123',
            productImg: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
            dateCreated: '08/06/2024',
            price: '$33.33',
            shipping: '$1',
            featuredPrice: '$38.33',
            competitivePrice: '$34.00',
            lowestPrice: '$30.33',
            remarks: '60 days to permanent deletion',
            status: 'Deleted',
        },
        {
            id: 2,
            name: 'Blue Colored Headphones',
            sku: 'Example123',
            productImg: require("../../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
            dateCreated: '08/06/2024',
            price: '$33.33',
            shipping: '$1',
            featuredPrice: '$38.33',
            competitivePrice: '$34.00',
            lowestPrice: '$30.33',
            remarks: '60 days to permanent deletion',
            status: 'Deleted',
        },
    ];

    const columns = [
        {
            name: 'Sr. no.',
            selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: 'Product Image',
            cell: (row) => <img src={row.productImg} alt={row.name} className={styles.productImg} />,
        },
        {
            name: 'Product Name',
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: 'SKU',
            selector: (row) => row.sku,
            sortable: true,
        },
        {
            name: 'Date Created',
            selector: (row) => row.dateCreated,
            sortable: true,
        },
        {
            name: 'Price + Shipping fee',
            cell: (row) => (
                <span>
                    {row.price} + {row.shipping}
                </span>
            ),
        },
        {
            name: 'Remarks',
            selector: (row) => row.remarks,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
        },
        {
            name: 'Action',
            cell: (row) => (
                <Dropdown isOpen={dropdownOpen[row.id]} toggle={() => toggleDropdown(row.id)} className={styles.actionDropdown}>
                    <DropdownToggle caret className={styles.dropdownButton}>
                        Action
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem>Edit</DropdownItem>
                        <DropdownItem>Deactivate</DropdownItem>
                        <DropdownItem>Delete</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            ),
        },
    ];

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <div className={styles.deletedProductsContainer}>

            <Container fluid className={styles.totalProducts}>
                <span>Total Products: 05</span>
            </Container>

            {loading ? <Loader /> :
                <ManageTable
                    name={'Inactive Deleted Products'}
                    columns={columns}
                    tableData={data}
                />
            }
        </div>
    );
};

export default DeletedProducts;
